import {
  InviteStyle as InviteStyleType,
  INVITE_STYLE,
} from "../meetingTypes/invite/props";

export type InviteStyle = InviteStyleType;

export interface InviteStyleOption {
  label: string;
  value: InviteStyle;
}

export const InviteStyleOptions: InviteStyleOption[] = [
  { label: "Kronologic Invite", value: INVITE_STYLE.CALENDAR_FIRST },
  { label: "Kronologic Email", value: INVITE_STYLE.CUSTOM_INVITE },
  { label: "Kronologic Link", value: INVITE_STYLE.LINK_FIRST },
  { label: "Kronologic Event", value: INVITE_STYLE.WEBINAR },
];
